import { supabase } from '../lib/supabase';

export const eventService = {
  getEvents: async (userId) => {
    const { data, error } = await supabase
      .from('events')
      .select('*, event_cards(count), card_leads(count)')
      .eq('user_id', userId)
      .order('start_date', { ascending: false });
    if (error) throw error;
    return data || [];
  },

  getEvent: async (id, userId) => {
    const { data, error } = await supabase
      .from('events')
      .select('*')
      .eq('id', id)
      .eq('user_id', userId)
      .single();
    if (error) throw error;
    return data;
  },

  createEvent: async (userId, eventData) => {
    const { data, error } = await supabase
      .from('events')
      .insert({ user_id: userId, ...eventData })
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  updateEvent: async (id, userId, updates) => {
    const { data, error } = await supabase
      .from('events')
      .update(updates)
      .eq('id', id)
      .eq('user_id', userId)
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  archiveEvent: async (id, userId) => {
    const { error } = await supabase
      .from('events')
      .update({ status: 'archived' })
      .eq('id', id)
      .eq('user_id', userId);
    if (error) throw error;
  },

  getLinkedCards: async (eventId) => {
    const { data, error } = await supabase
      .from('event_cards')
      .select('*, cards(*)')
      .eq('event_id', eventId);
    if (error) throw error;
    return data || [];
  },

  linkCard: async (eventId, cardId, isPrimary = false) => {
    const { error } = await supabase
      .from('event_cards')
      .upsert({ event_id: eventId, card_id: cardId, is_primary: isPrimary });
    if (error) throw error;
  },

  unlinkCard: async (eventId, cardId) => {
    const { error } = await supabase
      .from('event_cards')
      .delete()
      .eq('event_id', eventId)
      .eq('card_id', cardId);
    if (error) throw error;
  },

  getEventAnalytics: async (eventId) => {
    const { data, error } = await supabase.rpc('get_event_analytics', { p_event_id: eventId });
    if (error) throw error;
    return data;
  }
};